import React from "react";
import { Link } from "react-router-dom";

export default function TermsAndConditions() {
  return (
    <div className="min-h-screen bg-white text-black font-sans">
      {/* Prevent navbar overlap */}
      <div className="max-w-4xl mx-auto px-4 pt-28 pb-16">
        
        {/* Header Section */}
        <div className="mb-10 border-b border-gray-300 pb-6">
          {/* Breadcrumb */}
          <nav className="text-sm font-medium mb-3">
            <Link to="/" className="text-orange-600 hover:text-orange-700">
              Home
            </Link>
            <span className="mx-2 text-gray-500">/</span>
            <span className="text-gray-700">Terms and Conditions</span>
          </nav>

          <h1 className="text-3xl md:text-4xl font-black mb-2 uppercase tracking-tight">
            Terms and Conditions
          </h1>

          <p className="text-sm text-gray-600 italic">
            Last Updated: January 2026 | VIDYAZON (A Division of Admitere Educational Services Pvt. Ltd.)
          </p>
        </div>

        {/* CONTENT SECTION */}
        <div className="space-y-8 text-sm md:text-base leading-relaxed text-gray-800">
          
          {/* WELCOME / BINDING AGREEMENT */}
          <section className="bg-orange-50 p-6 rounded-xl border-l-4 border-orange-500">
            <p className="font-medium text-orange-900">
              By visiting or using the Portal, you agree that you have read, understood, and accepted these Terms and Conditions in full. If you do not agree, please discontinue use immediately.
            </p>
          </section>

          <p>
            Welcome to <strong>vidyazon.com</strong> (the “Portal”). This platform facilitates communication and education/skill-development services for students, parents, and institutions. Clicking “Accept” during signup binds you to these terms.
          </p>

          {/* 1. NO ACADEMIC CREDIT */}
          <section>
            <h2 className="text-xl font-bold mb-3 flex items-center">
              <span className="bg-black text-white px-2 py-1 rounded mr-3 text-xs">01</span>
              No Academic Credit
            </h2>
            <p>
              Participation in content or training via the Portal does not automatically confer academic credit. Credit recognition is solely at the discretion of the granting institution. 
            </p>
            <blockquote className="mt-3 border-l-2 border-gray-300 pl-4 italic text-gray-600">
              "Vidyazon has no obligation to ensure that Content Offerings are recognized by third-party accreditation bodies or employers."
            </blockquote>
          </section>

          {/* 2 & 3. DATA & ACCURACY */}
          <section className="grid grid-cols-1 md:grid-cols-2 gap-6">
            <div className="p-5 border border-gray-200 rounded-lg">
              <h3 className="font-bold mb-2">Data Usage</h3>
              <p className="text-sm">
                We process personal information (Name, IP, Education history, etc.) as detailed in our Privacy Policy to facilitate your applications and improve our services.
              </p>
            </div>
            <div className="p-5 border border-gray-200 rounded-lg">
              <h3 className="font-bold mb-2">Accuracy</h3>
              <p className="text-sm">
                You are responsible for providing accurate transcripts, test scores, and passport details. Vidyazon is not liable for rejections due to incorrect data.
              </p>
            </div>
          </section>

          {/* 4 & 5. INTELLECTUAL PROPERTY */}
          <section>
            <h2 className="text-xl font-bold mb-3 flex items-center">
              <span className="bg-black text-white px-2 py-1 rounded mr-3 text-xs">02</span>
              Intellectual Property & Copyright
            </h2>
            <p>
              The design, software, and materials on the Portal are owned by Vidyazon. 
            </p>
            <ul className="list-disc pl-5 mt-3 space-y-2 text-gray-700">
              <li><strong>Personal Use:</strong> You are granted a limited, revocable license for non-commercial use.</li>
              <li><strong>Prohibitions:</strong> No scraping, data mining, or commercial redistribution is allowed without written consent.</li>
              <li><strong>Trademarks:</strong> You may not use the Vidyazon logo or branding without authorization.</li>
            </ul>
          </section>

          {/* 7. REFUNDS */}
          <section className="bg-gray-50 p-6 rounded-xl">
            <h2 className="text-xl font-bold mb-3">Refund Policy</h2>
            <div className="overflow-x-auto">
              <table className="w-full text-left text-sm border-collapse">
                <thead>
                  <tr className="border-b border-gray-300">
                    <th className="py-2 font-bold">Service Type</th>
                    <th className="py-2 font-bold">Policy</th>
                  </tr>
                </thead>
                <tbody>
                  <tr className="border-b border-gray-200">
                    <td className="py-2">Vidyazon Subscriptions</td>
                    <td className="py-2">Subject to Vidyazon's internal rules at time of purchase.</td>
                  </tr>
                  <tr>
                    <td className="py-2">Third-Party Institutions</td>
                    <td className="py-2">Governed by the specific Institution/University refund policy.</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </section>

          {/* 9. CONSENT TO SHARING */}
          <section>
            <h2 className="text-xl font-bold mb-3 flex items-center">
              <span className="bg-black text-white px-2 py-1 rounded mr-3 text-xs">03</span>
              Data Sharing Consent
            </h2>
            <p>By using the Portal, you expressly authorize us to share your Personal Information with:</p>
            <div className="flex flex-wrap gap-2 mt-3">
              {["Universities", "Visa Consultants", "Coaching Providers", "Payment Gateways", "Testing Orgs"].map((tag) => (
                <span key={tag} className="bg-blue-100 text-blue-700 px-3 py-1 rounded-full text-xs font-semibold">
                  {tag}
                </span>
              ))}
            </div>
          </section>

          {/* 10. LIMITATION OF LIABILITY */}
          <section className="border-t border-gray-200 pt-8">
            <h2 className="text-xl font-bold mb-3">Limitation of Liability</h2>
            <p className="text-gray-600 text-sm">
              Vidyazon is a facilitator. We do not guarantee admission outcomes, visa approvals, or that the Portal will be 100% error-free. Use of the service is at your own risk.
            </p>
          </section>

          {/* CONTACT SECTION */}
          <section className="bg-orange-600 p-8 rounded-2xl text-white shadow-lg">
            <h2 className="text-2xl font-bold mb-4">Questions or Concerns?</h2>
            <p className="mb-6 opacity-90">
              If you have any questions regarding these terms, please reach out to our legal compliance team.
            </p>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
              <div className="bg-orange-700 p-4 rounded-lg">
                <p className="text-xs uppercase tracking-widest opacity-70">Email Us</p>
                <p className="font-bold">info@vidyazon.com</p>
              </div>
              <div className="bg-orange-700 p-4 rounded-lg">
                <p className="text-xs uppercase tracking-widest opacity-70">Global Office</p>
                <p className="font-bold text-sm">New Delhi, India</p>
              </div>
            </div>
          </section>

          <p className="text-center text-xs text-gray-400 pt-10">
            © {new Date().getFullYear()} Admitere Educational Services Pvt. Ltd. All rights reserved.
          </p>

        </div>
      </div>
    </div>
  );
}